import React, { useEffect, useState } from 'react'
import { useAlert } from 'react-alert'
import { useHistory, useLocation } from 'react-router-dom'
import { testContentModel } from '../../../domain/models/admin-models'
import CreateTest from '../../../presentation/components/new-test/create-test'
import { saveTest, updateTest } from '../../usecases/admin-menu/tests'
const CreateTestFactory = () => {
  const history = useHistory()
  const location: any = useLocation()
  const [testData, setTestData] = useState<testContentModel>()
  const alert = useAlert()
  useEffect(() => {
    setTestData(location.state)
  }, [location])
  const data = [
    {
      disabled: true,
      hasTestInput: 'true',
      component: 'Input',
      label: 'Código teste',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.cdTeste : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, cdTeste: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Nome',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.nome : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, nome: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Nome Satepsi',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.nomeSatepsi : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, nomeSatepsi: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Bateria',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.bateria : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, bateria: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Autores',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.autores : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, autores: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Editora',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.editora : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, editora: e.target.value }))
      }
    },
    {
      type: 'number',
      component: 'Input',
      label: 'Idade mínima',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.idadeMinima : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, idadeMinima: e.target.value }))
      }
    },
    {
      type: 'number',
      component: 'Input',
      label: 'Idade maxima',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.idadeMaxima : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, idadeMaxima: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Bibliografia',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.bibliografia : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, bibliografia: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Data de aprovação',
      type: 'date',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.dataAprovacao : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, dataAprovacao: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Prazo dos estudos de normatização',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.prazoEstudosNormatizacao : '',
      onChange: (e: any) => {
        setTestData((prev) => ({
          ...prev,
          prazoEstudosNormatizacao: e.target.value
        }))
      }
    },
    {
      component: 'Input',
      label: 'Data dos estudos de validade',
      type: 'date',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.prazoEstudosValidade : '',
      onChange: (e: any) => {
        setTestData((prev) => ({
          ...prev,
          prazoEstudosValidade: e.target.value
        }))
      }
    },
    {
      component: 'Input',
      label: 'Aplicação',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.aplicacao : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, aplicacao: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Correção',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.correcao : '',
      onChange: (e: any) => {
        setTestData((prev) => ({ ...prev, correcao: e.target.value }))
      }
    },
    {
      component: 'Input',
      label: 'Informações adicionais',
      labelColor: 'black',
      wrapperClassName: 'create-test-inputs',
      value: testData ? testData.informacoesAdicionais : '',
      onChange: (e: any) => {
        setTestData((prev) => ({
          ...prev,
          informacoesAdicionais: e.target.value
        }))
      }
    }
  ]
  const handleClick = async () => {
    try {
      testData?.cdTeste
        ? await updateTest().update(testData)
        : await saveTest().post(testData)
      alert.show('Teste salvo com sucesso', {
        type: 'success',
        timeout: 4000
      })
      history.push(`/cadastro-de-teste`)
    } catch (error) {
      alert.show('Erro ao salvar o teste', {
        type: 'error',
        timeout: 4000
      })
    }
  }
  return (
    <CreateTest
      data={data}
      handleClick={handleClick}
      active={testData?.ativo || false}
      setActive={() =>
        setTestData((prev) => ({ ...prev, ativo: !testData?.ativo }))
      }
    />
  )
}
export default CreateTestFactory
